import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DirectiveSuperclass } from '@sama/ng-core';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { DebugLoggingService } from './debug-logging.service';
import { FlagTechnicalIssueModalComponent } from './modals/flag-technical-issue-modal.component';
import { StartDebugLoggingModalComponent } from './modals/start-debug-logging-modal.component';

@Component({
  selector: 'h3-debug-logging-button',
  templateUrl: './debug-logging-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DebugLoggingButtonComponent extends DirectiveSuperclass {
  debugLoggingEnabled$ = inject(DebugLoggingService).debugLoggingEnabled$;

  private matDialog = inject(MatDialog);
  private store = inject(TaskWorkspaceStore);

  startDebugLogging() {
    this.matDialog.open(StartDebugLoggingModalComponent, {
      autoFocus: 'first-tabbable',
      data: { store: this.store },
    });
  }

  flagTechnicalIssue() {
    this.matDialog.open(FlagTechnicalIssueModalComponent, {
      autoFocus: 'first-tabbable',
    });
  }
}
